const discountVoucher = require('./discountVoucher');
const promoCode = require('./promoCode');
const orderSummary = require('./orderSummary');

const resolveBuilder = (moduleRef, namedExport) => {
    if (moduleRef && typeof moduleRef[namedExport] === 'function') {
        return moduleRef[namedExport];
    }
    if (moduleRef && moduleRef.default && typeof moduleRef.default[namedExport] === 'function') {
        return moduleRef.default[namedExport];
    }
    if (moduleRef && typeof moduleRef.default === 'function') {
        return moduleRef.default;
    }
    if (typeof moduleRef === 'function') {
        return moduleRef;
    }
    return null;
};

/**
 * Point d’ancrage du panier (bon + code promo + résumé) dans le formulaire Neos.
 * L’id attendu est #booking-form-flightInformation ; en secours, le fieldset parent
 * du champ date de vol (certaines versions / rendus du Form Builder).
 */
const resolveFlightInformationMount = () => {
    const byId = document.getElementById('booking-form-flightInformation');
    if (byId) {
        return byId;
    }
    const bySuffix = document.querySelector('fieldset[id$="-flightInformation"]');
    if (bySuffix) {
        return bySuffix;
    }
    const flightDate = document.getElementById('booking-form-flightDate');
    if (flightDate) {
        const withId = flightDate.closest('fieldset[id]');
        if (withId) {
            return withId;
        }
        return flightDate.closest('fieldset');
    }
    const flightType = document.getElementById('booking-form-flightType');
    if (flightType) {
        return flightType.closest('fieldset[id]') || flightType.closest('fieldset');
    }
    return null;
};

/**
 * Insère une seule fois le bloc panier sous « Détails du vol ».
 * Doit fonctionner pour une nouvelle réservation et lorsqu’un reste de session
 * (`sessionStorage.reservation`) fait passer `existingReservation` à true par erreur.
 */
const mountBookingBasketIfNeeded = () => {
    if (document.querySelector('.tc-website-basket')) {
        return true;
    }
    const mount = resolveFlightInformationMount();
    if (!mount) {
        console.warn('[TC.Website] Impossible de monter le panier : section « Détails du vol » introuvable.');
        return false;
    }

    const giftVoucherSettingsEl = document.getElementById('gift-voucher-code-length');
    const buildDiscountVoucherField = resolveBuilder(discountVoucher, 'buildDiscountVoucherField');
    const buildPromoCodeField = resolveBuilder(promoCode, 'buildPromoCodeField');

    if (giftVoucherSettingsEl && !buildDiscountVoucherField) {
        console.error('[TC.Website] buildDiscountVoucherField indisponible.');
        return false;
    }

    const discountVoucherField = giftVoucherSettingsEl && buildDiscountVoucherField
        ? buildDiscountVoucherField()
        : null;
    const promoField = buildPromoCodeField ? buildPromoCodeField() : null;
    const orderSummaryTable = orderSummary.buildOrderSummaryTable();

    const basketWrapper = document.createElement('div');
    basketWrapper.classList.add('tc-website-basket', 'clearfix');

    if (discountVoucherField) {
        basketWrapper.appendChild(discountVoucherField);
    }
    if (promoField) {
        basketWrapper.appendChild(promoField);
    }
    basketWrapper.appendChild(orderSummaryTable);
    mount.appendChild(basketWrapper);
    return true;
};

module.exports = { mountBookingBasketIfNeeded, resolveFlightInformationMount };
